<div *ngIf="code && codeToEmbedInQrCode" class="component-wrapper">
  <qrcode #qrCode
          (qrCodeURL)="onChangeURL($event)"
          [cssClass]="'center'"
          [elementType]="'canvas'"
          [errorCorrectionLevel]="'H'"
          [margin]="0"
          [qrdata]="this.codeToEmbedInQrCode"
          [scale]="1"
          [title]="'A custom title attribute'"
          [width]="isBigQrCode ? 600 : 200"
  ></qrcode>
  <div [ngClass]="isBigQrCode ? 'bigCode': ''" class="code-chars">
    <span *ngFor="let codeChar of this.codeArray" [ngClass]="{'code-colors': withColor}">
      {{ codeChar }}
    </span>
  </div>
</div>

